export const texts = {
  title: 'Основная информация',
}
